import React from "react";
import { render } from "react-dom";
import jQuery from "jquery";
import axios from "axios";
import "../css/home.css";
import Header from "../tracker/common/header";
import Footer from "../tracker/common/footer";
import { Bar } from "react-chartjs-2";

class GlobalData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      apptitle: this.props.apptitle,
      covidData: [],
      covidCountries: []
    };
  }

  componentDidMount = (e) => {
    //e.preventDefault();

    axios
      .get("https://api.covid19api.com/summary", this.state)
      .then((res) => {
        if (res.data) {
          var covidC = res.data.Countries;
          this.setState({ covidData: res.data });
          this.setState({ covidCountries: covidC });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    return (
      <section className="tracker-section">
        <Header title={this.props.apptitle} />

        <div className="container bodyContainer">
          <div className="row">
            <div className="col-12">
              <h2 className="headingColumn"> Global Data List</h2>
            </div>
            <div className="col-12 table-column " style={{ height: "450px" }}>
              <table className="table table-sm table-hovered table-data">
                <thead>
                  <tr>
                    <td>
                      <strong>Country</strong>
                    </td>
                    <td>
                      <strong>Confirmed</strong>
                    </td>
                    <td>
                      <strong>Active</strong>
                    </td>
                    <td>
                      <strong>Recovered</strong>
                    </td>
                    <td>
                      <strong>Deceased</strong>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {this.state.covidCountries.map((dataCountry) => (
                    <tr key={dataCountry.CountryCode}>
                      <td>{dataCountry.Country}</td>
                      <td>{dataCountry.TotalConfirmed}</td>
                      <td>{dataCountry.NewRecovered}</td>
                      <td>{dataCountry.TotalRecovered}</td>
                      <td>{dataCountry.TotalDeaths}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Footer />
          </div>
        </div>
      </section>
    );
  }
}

export default GlobalData;
